import styled from 'styled-components'
import { ErrorIcon } from '../Message/ErrorIcon'

export const ProvisionalLicenceIcon = styled(ErrorIcon)`
  color: ${(props) => props.theme.secondaryColour};
  border: 2px solid ${(props) => props.theme.secondaryColour};
  border-radius: 50%;
  padding: 5px;
  padding-bottom: 10px;
`
